module.exports = __webpack_public_path__ + "img/TXCVT-Logo.6463d138.jpg";